import Home from './Home.banners'

export default {
  Home
}
